<template>
	<Subscriptions :isPublic="true" />
</template>

<script>
	import { mapMutations } from "vuex";
	import Subscriptions from "./Account/Subscriptions.vue";
	export default {
		name: "SubscriptionsPublic",
		components: { Subscriptions },
		data() {
			return {
				email: "",
				errors: {},
				inputErrors: {},
				okToSubmit: true,
			};
		},
		computed: {},
		methods: {
			...mapMutations("general", ["updateLoadingText"]),
		},
	};
</script>
